import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTwitter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.60169 6.97921L14.5653 1.33337H13.389L9.07921 6.23546L5.63687 1.33337H1.6665L6.87196 8.74629L1.6665 14.6667H2.84284L7.39423 9.48994L11.0295 14.6667H14.9998L9.60137 6.97921H9.60169ZM7.9906 8.8115L7.46311 8.07337L3.26664 2.19983H5.0734L8.45985 6.94004L8.98723 7.67817L13.3895 13.8396H11.5829L7.9906 8.81181V8.8115Z",
		fill: "currentColor"
	})
});
export default SvgTwitter;
